import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SnackbarService } from '../../../_service/message-service';
import { LoaderService } from 'src/app/loader.service';
import { RfidServiceService } from 'src/app/_service/rfid-service.service';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { Role } from '../../../util/enums/role.enum';
import { UserInfoService } from 'src/app/_services/userInfo.service';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'YYYY-MM-DD',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },
};

@Component({
  selector: 'telio-rfid-edit',
  templateUrl: './rfid-edit.component.html',
  styleUrls: ['./rfid-edit.component.scss'],
  providers: [

    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class RfidEditComponent implements OnInit, OnDestroy {
  rfidSubscription = new Subscription()
  createRfid: UntypedFormGroup;
  public statusSelect = 'pending';
  disableSelect = new UntypedFormControl(false);
  masterRfidList = [];
  nextyearDate;
  rfidTag;
  cookieDetails;
  rfidDetails;
  selected;
  position;
  minDate;

  constructor(private formBuilder: UntypedFormBuilder,
    private route: ActivatedRoute,
    private rfidService: RfidServiceService,
    private userInfoService: UserInfoService,
    private router: Router,
    private toastr: SnackbarService,
    public loaderService: LoaderService,
    readonly translate: TranslateService) { }

  ngOnInit(): void {
    this.minDate = new Date();
    this.route.queryParams.subscribe((params) => {
      this.rfidTag = params.rfidId;
    });
    this.rfidSubscription.add(this.rfidService.getRfidDetailsById(this.rfidTag).subscribe(resp => {
      this.rfidDetails = resp;
      this.selected = this.rfidDetails.status
      this.editForm()
    }))
    this.nextyearDate = new Date();
    this.nextyearDate.setDate(this.nextyearDate.getDate() + 364);
    this.rfidSubscription.add(this.rfidService.getMasterCards().subscribe(resp => {
      this.masterRfidList = resp.content;
    },
    error => {
      this.toastr.error(error.message)
    }))
    this.cookieDetails = this.userInfoService.userDetails;
  }

  editForm() {
    this.createRfid = this.formBuilder.group({
      rfid_tag: [{ value: this.rfidDetails.id_tag, disabled: true }, Validators.compose([
        Validators.required
      ])],
      user_id: [{ value: this.rfidDetails.user_id, disabled: true }, Validators.compose([
      ])],
      user_name: [{ value: this.rfidDetails.username, disabled: true }, Validators.compose([
      ])],
      expiration_date: [this.rfidDetails.expired_date, Validators.required],
      master_rfid: [this.rfidDetails.master_rfid_card],
      comment: [this.rfidDetails.comments, Validators.compose([
        Validators.required])],
      status: [{ value: this.rfidDetails.status, disabled: true }]
    })

  }

  resetmethod() {
    this.ngOnInit();
  }

  dateConvert(date) {
    let exDate = new Date(date);
    let tempDate = exDate.toISOString();
    let result = tempDate.split('.')[0];
    // return result = result + "+05:30";
    return result =  result + "Z";
  }

  onSubmit() {
    this.position = this.rfidDetails.position;
    if (this.createRfid.value.comment == "" || null) {
      this.toastr.error(this.translate.instant('rfid.commentError'));
      return;
    }
    let expDate;
    this.position = (this.createRfid.value.master_rfid == null) ? 0 : 1;
    expDate = (this.createRfid.value.expiration_date == this.rfidDetails.expired_date) ? this.rfidDetails.expired_date : (this.createRfid.value.expiration_date).toISOString()
    let input = {
      "id_tag": this.rfidDetails.id_tag,
      "user_id": this.rfidDetails.user_id,
      "created_date": this.rfidDetails.created_date,
      "created_by_id": this.rfidDetails.created_by_id,
      "created_by_name": this.rfidDetails.created_by_name,
      "expired_date": expDate,
      "updated_date": this.dateConvert(new Date()),
      "updated_by": this.userInfoService.groups.find(role => role === Role.CPO || role === Role.SUPERADMIN || role === Role.ADMIN),
      "comments": this.createRfid.value.comment,
      "position": this.position,
      "owner": this.userInfoService.groups.find(role => role === Role.CPO || role === Role.SUPERADMIN || role === Role.ADMIN),
      "master_rfid_card": this.createRfid.value.master_rfid

    }
    this.rfidSubscription.add(this.rfidService.updateRfidCard(input).subscribe(resp => {
      if (!!resp) {
        this.toastr.success(this.translate.instant('rfid.successUpdate'))
        this.routeBack();
      }
    },
      error => {
        this.toastr.error(error.message);
      }))
  }

  routeBack() {
    this.router.navigate(['/dashboard/rfid', { routeID: this.route.snapshot.paramMap.get('routeID') }])
  }

  ngOnDestroy() {
    this.rfidSubscription && this.rfidSubscription.unsubscribe();
  }
}
